import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import RouterConstants from "../../../constants/RouterConstants";
import { getSelectedOrganization } from "../../../helpers/localStorage";
import { useAppStore } from "../../../hooks/useStores";
import BriaButton from "../../common/BriaButton/BriaButton";
import styles from "./ConsoleIframe.module.scss";

interface Props {
	translationPrefix: string;
	className?: string;
}

const ConsoleIframe = ({ translationPrefix, className }: Props) => {
	const { t } = useTranslation("translation", { keyPrefix: translationPrefix });
	const selectedOrg = getSelectedOrganization();
	const { uiStore } = useAppStore();
	return (
		<Box className={`${styles.wrapper} ${className || ""}`}>
			<Typography className={styles.title}>{t("title")}</Typography>
			<Typography className={styles.description} dangerouslySetInnerHTML={{ __html: t("description") }} />
			<NavLink
				onClick={(e) => {
					if (!selectedOrg) {
						e.preventDefault();
						uiStore.showDialog("CreateOrganizationDialog");
					}
				}}
				className={styles.primaryBtn}
				to={RouterConstants.ACCOUNT_IFRAMES.fullPath}
			>
				<BriaButton buttonType="primaryMedium">{t("primaryButton")}</BriaButton>
			</NavLink>
		</Box>
	);
};

export default observer(ConsoleIframe);
